

import __layout_0 from '/home/runner/work/ECM/ECM/client/src/layouts/default.vue'
export const layouts = {
'404': () => import('/home/runner/work/ECM/ECM/client/src/layouts/404.vue'),
'default': __layout_0,
}

export function setupLayouts(routes) {
  return routes.map(route => {
    return { 
      path: route.path,
      meta: route.meta,
      component: layouts[route.meta?.layout || 'default'],
      children: route.path === '/' ? [route] : [{...route, path: ''}]
    }
  })
}
